export default {
    updatedProfileLink: ""
}